import { Controller } from '@hotwired/stimulus'

// Asks for confirmation before the enclosing Bootstrap modal is closed by the user
// (a turbo-updated-modal#close button or Esc). Hides the server asks for with the
// close_modal stream action, e.g. after deleting an attachment, pass through.
// Content that no longer needs the guard simply renders without this controller.
export default class extends Controller {
  static values = { message: String }

  connect() {
    this.modal = this.element.closest('.modal')
    this.noteCloseIntent = this.noteCloseIntent.bind(this)
    this.confirmHide = this.confirmHide.bind(this)
    this.modal?.addEventListener('keydown', this.noteCloseIntent, true)
    this.modal?.addEventListener('click', this.noteCloseIntent, true)
    this.modal?.addEventListener('hide.bs.modal', this.confirmHide)
  }

  disconnect() {
    this.modal?.removeEventListener('keydown', this.noteCloseIntent, true)
    this.modal?.removeEventListener('click', this.noteCloseIntent, true)
    this.modal?.removeEventListener('hide.bs.modal', this.confirmHide)
  }

  noteCloseIntent(event) {
    this.userClosing = event.type === 'keydown'
      ? event.key === 'Escape'
      : !!event.target.closest('[data-action*="turbo-updated-modal#close"]')
    setTimeout(() => { this.userClosing = false })
  }

  confirmHide(event) {
    if (!this.userClosing) return

    this.userClosing = false
    if (!window.confirm(this.messageValue)) event.preventDefault()
  }
}
